import React, { useEffect, useState, Fragment } from "react";
import { Pagination, PageHeader, paginate } from "../../../Common";
import { CreateQRTagTable } from "../../Common/Table/tableContent";
import services from "../services";
import $ from "jquery";
import authService from "../../Common/services";
import { LoadingSpinerComponent } from "../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi from "@hapi/joi";
import { QRTagGenerationWithFactorySchemaObject } from "../QRTagGenerationWithFactorySchema";
import { validateProperty, validate } from "../../Common";
import MessageModal from "../../../UI/Modal/MessageModal";
import tokenService from "../../../Common/tokenDecoder";

const screenCode = "QRTAGGENERATIONWITHFACTORY";

export function QRTagGenerationWithFactory(props) {
  const [groups, setGroups] = useState([]);
  const [operationEntity, setOperationEntity] = useState([]);
  const [routes, setRoutes] = useState([]);
  const [errors, setErrors] = useState({});
  const [permissionList, setPermissions] = useState({
    isAddEditEnabled: false,
    isGroupFilterEnabled: false,
    isOperationEntityFilterEnabled: false,
  });
  const [istableHidden, setIstableHidden] = useState(true);
  const [qrTagDetails, setQrTagDetails] = useState([]);
  const [messageModel, setMessageModel] = useState({
    hidden: true,
    type: "Success",
    disciption: "Completed successfuly.",
  });
  const contentRowNames = ["tagNo"];
  const [qrTag, setQRTag] = useState({
    groupID: "0",
    operationEntityID: "0",
    routeID: "0",
    noOfCodes: "0",
  });

  const schema = Joi.object(QRTagGenerationWithFactorySchemaObject).options({ allowUnknown: true });

  useEffect(() => {
    trackPromise(getPermissions());
  }, []);

  useEffect(() => {
    if (qrTag.groupID != 0 || qrTag.groupID != "") {
      trackPromise(getOperationEntityByGroup());
    }
  }, [qrTag.groupID]);

  useEffect(() => {
    trackPromise(
      getAllRoutesForDropDown()
    )
  }, [qrTag.operationEntityID]);

  async function getPermissions() {
    var permissions = await authService.getPermissionsByScreen(screenCode);

    var isAuthorized = permissions.find((p) => p.permissionCode == "VIEWQRTAGGENERATIONWITHFACTORY");

    if (isAuthorized === undefined) {
      props.history.push("/unauthorized");
    }
    var isGroupFilterEnabled = permissions.find(
      (p) => p.permissionCode == "GROUPDROPDOWN"
    );
    var isOperationEntityFilterEnabled = permissions.find(
      (p) => p.permissionCode == "OPERATIONENTITYDROPDOWN"
    );

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined,
    });

    var token = tokenService.getUserDetailsFromToken();

    setQRTag({
      ...qrTag,
      groupID: token.groupID,
      operationEntityID: token.operationEntityID,
    });

    trackPromise(getGroupsForDropdown());
  }

  async function getGroupsForDropdown() {
    const result = await services.getAlGroupsForDropdown();
    setGroups(result);
  }

  async function getOperationEntityByGroup() {
    const data = await services.getOperationEntityByGroup(qrTag.groupID);
    setOperationEntity(data);
  }

  async function getAllRoutesForDropDown() {
    const routeList = await services.getAllRoutesByFactoryID(qrTag.operationEntityID);
    setRoutes(routeList);
  }

  function validateInputs(target) {
    const error = { ...errors };
    const errorMessage = validateProperty(target, QRTagGenerationWithFactorySchemaObject);
    errorMessage
      ? (error[target.name] = errorMessage)
      : delete error[target.name];

    setErrors(error);
  }


  function destroyDataTable() {
    $("#example").DataTable().destroy();
  }

  function createDataTable() {
    $("#example").DataTable();
  }

  function handleGroupChange(target) {
    validateInputs(target);

    setQRTag({
      ...qrTag,
      groupID: target.value,
      operationEntityID: "0",
      routeID: "0",
      noOfCodes: "0",
    });
  }

  function handleOperationEntityChange(target) {
    validateInputs(target);

    setQRTag({
      ...qrTag,
      operationEntityID: target.value,
      routeID: "0",
      noOfCodes: "0",
    });
  }

  function handleChange(e) {
    e.preventDefault();

    const target = e.target;
    const value = target.value;

    const error = { ...errors };
    const errorMessage = validateProperty(target, QRTagGenerationWithFactorySchemaObject);
    errorMessage ? error[target.name] = errorMessage : delete error[target.name];

    setQRTag({
      ...qrTag,
      [e.target.name]: value
    })
  }
  function handleNoOfCodesChange(target) {
    validateInputs(target);

    setQRTag({
      ...qrTag,
      noOfCodes: target.value,
    });
  }
  function generateDropDownMenu(data) {
    let items = [];
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(
          <MenuItem key={key} value={key}>
            {value}
          </MenuItem>
        );
      }
    }
    return items;
  }

  async function handleGenerate(e) {
    e.preventDefault();

    const errorMessages = validate(schema, qrTag);
    errorMessages !== null ? setErrors(errorMessages) : setErrors({});
    if (errorMessages) return;

    const response = await services.createQRtag(qrTag);
    setQrTagDetails(response);
    setIstableHidden(false);
  }

  async function handleSave(e) {
    e.preventDefault();

    if (qrTagDetails.length > 0) {
      const response = await services.saveQRtags(qrTagDetails);
      setMessageModel({
        ...messageModel,
        hidden: false,
        type: response.statusCode,
        disciption: response.message,
      });

      if ((response.statusCode = true)) {
        setQrTagDetails([]);
        setIstableHidden(true);
        setTimeout(() => {
          setMessageModel({ ...messageModel, hidden: true })
        }, 1500);
      }
    }
  }

  function modalDismissHandler() {
    setMessageModel({ ...messageModel, hidden: true });
  }

  return (
    <Fragment>
      <LoadingSpinerComponent />
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <PageHeader
              title="QR Tag Generation With Factory"
              isButtonEnable={permissionList.isAddEditEnabled}
            />
            <div className="card-body">
              <form
                onSubmit={(e) => trackPromise(handleGenerate(e))}
                disabled={false}
              >
                <div className="form-group row">
                  <div className="col-md pb-1">
                    <InputLabel shrink id="groupID">
                      Group *
                    </InputLabel>
                    <Select
                      fullWidth
                      labelId="groupID"
                      id="groupID"
                      name="groupID"
                      value={qrTag.groupID}
                      disabled={!permissionList.isGroupFilterEnabled}
                      onChange={(e) => handleGroupChange(e.target)}
                    >
                      <MenuItem value="0">--Select Group--</MenuItem>
                      {generateDropDownMenu(groups)}
                    </Select>
                    {errors["groupID"] && (
                      <FormHelperText error>{errors["groupID"]}</FormHelperText>
                    )}
                  </div>

                  <div className="col-md pb-1">
                    <InputLabel shrink id="operationEntityID">
                      Operation Entity *
                    </InputLabel>
                    <Select
                      fullWidth
                      labelId="operationEntityID"
                      id="operationEntityID"
                      name="operationEntityID"
                      value={qrTag.operationEntityID}
                      disabled={!permissionList.isOperationEntityFilterEnabled}
                      onChange={(e) => handleOperationEntityChange(e.target)}
                    >
                      <MenuItem value="0">--Select Operation Entity--</MenuItem>
                      {generateDropDownMenu(operationEntity)}
                    </Select>
                    {errors["operationEntityID"] && (
                      <FormHelperText error>
                        {errors["operationEntityID"]}
                      </FormHelperText>
                    )}
                  </div>
                  <div className="col-md pb-1">
                    <InputLabel shrink id="routeID">Route *</InputLabel>
                    <Select
                      fullWidth
                      id="routeID"
                      name="routeID"
                      value={qrTag.routeID}
                      onChange={(e) => handleChange(e)}>
                      <MenuItem value="0">--Select Route--</MenuItem>
                      {generateDropDownMenu(routes)}
                    </Select>
                    {errors["routeID"] && (
                      <FormHelperText error>
                        {errors["routeID"]}
                      </FormHelperText>
                    )}
                  </div>
                  <div className="col-md pb-1">
                    <TextField
                      fullWidth
                      label="No. of codes *"
                      name="noOfCodes"
                      id="noOfCodes"
                      value={qrTag.noOfCodes}
                      type="number"
                      onChange={(e) => handleNoOfCodesChange(e.target)}
                    />

                    {errors["noOfCodes"] && (
                      <FormHelperText error>
                        {errors["noOfCodes"]}
                      </FormHelperText>
                    )}
                  </div>
                </div>

                <div className="card-footer">
                  <input
                    type="submit"
                    className="btn btn-primary"
                    value="Generate"
                  />
                </div>
              </form>

              <div hidden={istableHidden} >
                <table id="blockWeighment" className="display dataTable no-footer">
                  <thead>
                    <tr>
                      <th>QR Tags</th>
                    </tr>
                  </thead>
                  <tbody>
                    <CreateQRTagTable
                      data={qrTagDetails}
                      contentRowNames={contentRowNames}
                      hasEdit={false}
                    />
                  </tbody>
                </table>
                <div className="card-footer">
                  <input
                    type="submit"
                    className="btn btn-primary"
                    value="Save"
                    onClick={(e) => trackPromise(handleSave(e))}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <MessageModal
        hidden={messageModel.hidden}
        messageType={messageModel.type}
        messageDescription={messageModel.disciption}
        clicked={modalDismissHandler}
      />
    </Fragment>
  );
}
